module.exports = __webpack_public_path__ + "34b900db00e58e7fb9f52ee707e25d51.svg";